// Add your custom JS here.

(function ($) {
    $(window).on('load resize', function () {
    });
    function checkHeight(ele) {
        var h = 0;
        $(ele).each(function () {
            if ($(this).height() > h) {
                h = $(this).height();
            }
        });
        $(ele).css('height', h + 'px');
    }

    function setFullHeight() {
        document.documentElement.style.setProperty('--vh', `${window.innerHeight}px`);
        
        let vw = window.innerWidth;
        if(vw < 992) {
            const sibarToolsCat = document.querySelector('.sibarTools__cat');
            if(sibarToolsCat) {
                sibarToolsCat.classList.remove('d-flex');
                sibarToolsCat.classList.add('d-none');
            }
        }
    }

    window.addEventListener('resize', setFullHeight);
    setFullHeight();

    $(document).ready(function () {

        $(window).on('scroll', function () {
            if ($(window).scrollTop() > 100) {
                $('.toTop').addClass('active');
            } else {
                $('.toTop').removeClass('active');
            }

            if ($(window).scrollTop() > 5) {
                $('.header').addClass('fixed');
            } else {
                $('.header').removeClass('fixed');
            }
        });

        $('.toTop').on('click', function (e) {
            e.preventDefault();
            $('html, body').animate({
                scrollTop: 0
            }, 'swing');
        });

        $('.menu-item-has-children').append('<button type="button" class="btnSub"><i class="far fa-angle-down"></i></button>');

        $(document).on('click', '.btnSub', function (e) {
            e.preventDefault();
            $(this).toggleClass('active').siblings('.subMenu').slideToggle(300);
        });

        $(document).on('click', '.toggleMenu', function (e) {
            e.preventDefault();
            $('.header').toggleClass('active');
        });

        $(document).on('click', '.home .sibarTools__cat .term', function (e) {
            e.preventDefault();
            $(this).addClass('active').siblings('.term.active').removeClass('active');

            const termid = $(this).data('term');

            $.ajax({
                url: ajax_object.ajax_url,
                type: 'POST',
                dataType: 'json', // Yêu cầu phản hồi dạng JSON
                data: {
                    action: 'get_tools_by_term', // Action name khớp với PHP
                    termid: termid,
                    nonce: ajax_object.nonce
                    // Thêm các tham số khác nếu bạn có (ví dụ: category_id)
                },
                beforeSend: function() {
                    $('.popularList, .recentList').addClass('loadData');
                },
                success: function (response) {
                    if(response.success) {
                        const data = response.data;
                        const viewTarget = document.getElementById('nav-tab');

                        if(data.termLink) {
                            $('.homeTab__viewall').attr('href', data.termLink);
                        } else {
                            $('.homeTab__viewall').attr('href', 'javascript:;');
                        }

                        if(data.popular) {
                            $('.popularList').removeClass('loadData').html(data.popular);
                        } else {
                            $('.popularList').removeClass('loadData').html(`<p>Chưa có tool</p>`);
                        }

                        if(data.recent) {
                            $('.recentList').removeClass('loadData').html(data.recent);
                        } else {
                            $('.recentList').removeClass('loadData').html(`<p>Chưa có tool</p>`);
                        }

                        viewTarget.scrollIntoView({
                            behavior: 'smooth',
                            block: 'start',
                            inline: 'nearest'
                        });
                    }
                },
                error: function (xhr, status, error) {
                }
            });
        });

        $('.sibarTools__title').on('click', function(e) {
            e.preventDefault();
            if($(this).hasClass('active')) {
                $(this).removeClass('active').siblings('.sibarTools__cat').removeClass('d-flex').addClass('d-none');
            } else {
                $(this).addClass('active').siblings('.sibarTools__cat').removeClass('d-none').addClass('d-flex');
            }
        });

        function runCounter($element) {
            if (!$element.hasClass("counted")) {
                var numberString = $element.html();
                var cleanedNumberString = numberString.replace(/\./g, '');
                var targetNumber = parseInt(cleanedNumberString, 10);

                if (!isNaN(targetNumber)) {
                    $element.addClass("counted");
                    $({ countNum: 0 }).animate({ countNum: targetNumber }, {
                        duration: 3000,
                        easing: "linear",
                        step: function () {
                            let currentNum = Math.floor(this.countNum);
                            let formattedNum = currentNum.toLocaleString('de-DE', {
                                minimumFractionDigits: 0,
                                maximumFractionDigits: 0
                            });
                            $element.text(formattedNum);
                        },
                        complete: function () {
                            let formattedTarget = targetNumber.toLocaleString('de-DE', {
                                minimumFractionDigits: 0,
                                maximumFractionDigits: 0
                            });
                            $element.text(formattedTarget);
                        }
                    });
                } else {
                    console.error("Lỗi: Không thể chuyển đổi '" + numberString + "' thành số hợp lệ.");
                }
            }
        }

        setTimeout(function () {
            AOS.init({ disable: 'mobile', once: true });
        }, 500);

        if ($(['data-fancybox']).length) {
            $('data-fancybox').fancybox();
        }

        if ($('.prodContent__body').length) {
            const tableElem = $('.prodContent__body table');
            if (tableElem) {
                setTimeout(() => {
                    tableElem.each((idx, elem) => {
                        $(elem).wrap('<div class="tableWrap"></div>');
                    });
                }, 1000);
            }
        }

    });

    document.addEventListener('DOMContentLoaded', function () {
        const historyWrap = document.querySelector('.aboutHistory__wrap');
        const historyBox = document.querySelector('.aboutHistory__box');
        let isDragging = false;
        let startX;
        let scrollLeft;

        if (historyWrap && historyBox) {
            historyWrap.addEventListener('mousedown', (e) => {
                isDragging = true;
                startX = e.pageX - historyBox.offsetLeft;
                scrollLeft = historyWrap.scrollLeft;
                historyWrap.style.cursor = 'grabbing';
            });

            historyWrap.addEventListener('mouseleave', () => {
                isDragging = false;
                historyWrap.style.cursor = 'grab';
            });

            historyWrap.addEventListener('mouseup', () => {
                isDragging = false;
                historyWrap.style.cursor = 'grab';
            });

            historyWrap.addEventListener('mousemove', (e) => {
                if (!isDragging) return;
                e.preventDefault();
                const x = e.pageX - historyBox.offsetLeft;
                const walk = (x - startX) * 1; // Điều chỉnh hệ số này để thay đổi tốc độ kéo
                historyWrap.scrollLeft = scrollLeft - walk;
            });
        }
    });

    // Chờ toàn bộ trang và tài nguyên được tải xong
    window.addEventListener('load', () => {

        // Tìm tất cả các phần tử có class 'js-marquee-container' trên trang
        // Bạn cần thêm class này vào các div chứa marquee của mình trong HTML
        const marqueeContainers = document.querySelectorAll('.myMarquee');

        // Lặp qua từng phần tử tìm được và thiết lập marquee cho mỗi phần tử
        marqueeContainers.forEach(marqueeContainer => {
            // Gọi hàm setupMarquee cho từng container
            setupMarquee(marqueeContainer);
        });

    });

    // Hàm để thiết lập và chạy animation cho một marquee cụ thể
    function setupMarquee(marqueeContainer) {
        // Kiểm tra xem container có tồn tại không
        if (!marqueeContainer) {
            console.error("Marquee container element not provided.");
            return;
        }

        const marqueeWrapper = marqueeContainer.querySelector('.marqueeContainer');
        if (!marqueeWrapper) {
            console.error("Marquee wrapper '.marqueeContainer' not found inside the provided container.", marqueeContainer);
            return;
        }

        const originalItems = Array.from(marqueeWrapper.children);
        if (originalItems.length === 0) {
            console.warn("Marquee wrapper has no child elements inside container.", marqueeContainer);
            return; // Không có phần tử để tạo hiệu ứng
        }

        // --- Cấu hình (Có thể lấy từ data- attribute nếu muốn tùy chỉnh cho từng marquee) ---
        // Đọc cấu hình từ data- attribute trên container (nếu có) hoặc dùng giá trị mặc định
        const speed = parseFloat(marqueeContainer.dataset.speed) || 80; // pixels per second
        const direction = parseInt(marqueeContainer.dataset.direction) || -1; // -1: Left, 1: Right
        const pauseOnHover = marqueeContainer.dataset.pauseOnHover !== 'false'; // Mặc định là true trừ khi là 'false'

        // --- Nhân bản các phần tử ---
        // Xóa các phần tử nhân bản cũ nếu hàm được gọi lại (ví dụ: trong quá trình phát triển)
        // Giữ lại số lượng phần tử ban đầu
        while (marqueeWrapper.children.length > originalItems.length) {
            marqueeWrapper.removeChild(marqueeWrapper.children[originalItems.length]);
        }

        // Nhân bản các phần tử ban đầu
        originalItems.forEach(item => {
            const clone = item.cloneNode(true);
            // Tùy chọn: Thêm class hoặc attribute để nhận diện bản sao
            // clone.setAttribute('data-clone', 'true');
            marqueeWrapper.appendChild(clone);
        });

        // --- Tính toán chiều rộng và thời lượng dựa trên chiều rộng thực tế sau khi render ---
        // Sử dụng requestAnimationFrame để đảm bảo các style và layout đã được tính toán xong
        requestAnimationFrame(() => {
            // Đo tổng chiều rộng của wrapper chứa cả phần tử gốc + bản sao
            const totalWidth = marqueeWrapper.scrollWidth;

            // Chiều rộng cần thiết cho một chu kỳ chạy là chiều rộng của các phần tử gốc
            // Vì đã nhân đôi, chiều rộng của phần tử gốc là một nửa totalWidth
            const resetWidth = totalWidth / 2; // Đây là chiều rộng của nội dung gốc (trước khi nhân đôi)

            // Kiểm tra xem nội dung có đủ rộng để cuộn hay không
            if (resetWidth <= 0 || resetWidth <= marqueeContainer.offsetWidth) {
                // console.warn("Marquee content is not wide enough to scroll or width calculation failed for container.", marqueeContainer);
                // Xóa các bản sao nếu không cuộn
                while (marqueeWrapper.children.length > originalItems.length) {
                    marqueeWrapper.removeChild(marqueeWrapper.children[originalItems.length]);
                }
                // Tùy chọn: Thêm style để nội dung hiển thị bình thường nếu không cuộn
                marqueeWrapper.style.animation = 'none';
                marqueeWrapper.style.transform = 'translateX(0)';
                return; // Không có gì để tạo hiệu ứng
            }

            // Tính toán thời lượng animation (đơn vị miliseconds)
            // Thời lượng = Quãng đường / Tốc độ * 1000
            const duration = (speed > 0) ? (resetWidth / speed) * 1000 : 0;

            // Hủy bỏ animation cũ nếu có (trường hợp hàm được gọi lại)
            if (marqueeWrapper.animation) {
                marqueeWrapper.animation.cancel();
            }

            // --- Tạo Animation sử dụng WAAPI ---
            if (duration > 0) {
                // Keyframes cho animation cuộn lặp vô hạn
                // Cuộn từ 0 đến -resetWidth (đối với direction -1)
                // Cuộn từ 0 đến +resetWidth (đối với direction 1 - cần kiểm tra lại logic này)
                // Để đảm bảo lặp mượt, điểm bắt đầu và kết thúc cần cách nhau đúng bằng resetWidth
                // Nếu cuộn sang trái (-1): Bắt đầu 0px, Kết thúc -resetWidth px
                // Nếu cuộn sang phải (1): Bắt đầu -resetWidth px, Kết thúc 0px HOẶC Bắt đầu 0px, Kết thúc +resetWidth px (cần điều chỉnh CSS overflow/position)
                // Với setup hiện tại, cuộn sang trái là phổ biến và dễ setup nhất với translateX(0) -> translateX(-resetWidth)
                let keyframes;
                if (direction === -1) { // Cuộn sang trái
                    keyframes = [
                        { transform: 'translateX(0)' },
                        { transform: 'translateX(' + (-resetWidth) + 'px)' }
                    ];
                } else { // Cuộn sang phải (cần điều chỉnh lại một chút logic hoặc CSS để nó mượt)
                    // Cách đơn giản nhất cho cuộn phải với clone là cuộn từ -resetWidth -> 0
                    keyframes = [
                        { transform: 'translateX(' + (-resetWidth) + 'px)' },
                        { transform: 'translateX(0)' }
                    ];
                    // Điều chỉnh tốc độ nếu cần thiết cho cuộn phải để cảm giác tương tự
                    // Hoặc điều chỉnh điểm bắt đầu/kết thúc keyframes và vị trí ban đầu của wrapper
                }


                const animation = marqueeWrapper.animate(
                    keyframes,
                    {
                        duration: duration,
                        iterations: Infinity, // Lặp vô hạn
                        easing: 'linear' // Tốc độ đều
                    }
                );

                // Lưu đối tượng animation vào phần tử wrapper để dễ truy cập
                marqueeWrapper.animation = animation;

                // --- Xử lý Dừng/Chạy khi di chuột qua ---
                if (pauseOnHover) {
                    // Sử dụng function expressions để dễ dàng gỡ bỏ listener sau này nếu cần
                    const pauseAnimation = () => marqueeWrapper.animation?.pause();
                    const playAnimation = () => marqueeWrapper.animation?.play();

                    // Thêm listener vào phần tử container (bao ngoài)
                    marqueeContainer.addEventListener('mouseenter', pauseAnimation);
                    marqueeContainer.addEventListener('mouseleave', playAnimation);

                    // Tùy chọn: Lưu lại listener để có thể gỡ bỏ trong tương lai (ví dụ khi xóa marquee)
                    marqueeContainer.animationListeners = { pauseAnimation, playAnimation };
                }
            } else {
                // Nếu thời lượng bằng 0 (tốc độ bằng 0), đảm bảo xóa bản sao
                while (marqueeWrapper.children.length > originalItems.length) {
                    marqueeWrapper.removeChild(marqueeWrapper.children[originalItems.length]);
                }
                marqueeWrapper.style.animation = 'none'; // Đảm bảo không có animation CSS cũ
                marqueeWrapper.style.transform = 'translateX(0)'; // Đảm bảo về vị trí ban đầu
            }
        }); // Kết thúc requestAnimationFrame

    }

})(jQuery)